import type { ReactNode } from 'react';
import { EnvironmentBanner } from '@common/components/EnvironmentBanner';
import { Box } from '@mui/material';
import _ from 'lodash';

import type { Store } from '@campaign/domain/store';
import * as user from '@campaign/domain/middlewares/user';
import { runAppInitialization } from '@campaign/domain/runAppInitialization';
import { useStoreSelector } from '@campaign/domain/store/useStoreState';
import { CampaignFooter } from '@campaign/view/components/CampaignFooter';
import { CampaignHeader } from '@campaign/view/components/CampaignHeader';

type Props = {
  children: ReactNode;
  store: Store;
};

export function Page({ children, store }: Props) {
  runAppInitialization(store);

  const onClickLogin = _.partial(user.onLogin, store);
  const onClickLogout = _.partial(user.onClickLogoutMenuItem, store);
  const userIsLoggedIn = useStoreSelector(
    (state) => state.loggedInUser.isLogged
  );
  const name = useStoreSelector(
    (state) => state.loggedInUser.lastName + state.loggedInUser.firstName
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <EnvironmentBanner />
      <CampaignHeader
        name={name}
        onClickLogin={onClickLogin}
        onClickLogout={onClickLogout}
        onClickMemberProfileMenuItem={user.onClickMemberProfileMenuItem}
        userIsLoggedIn={userIsLoggedIn}
      />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <CampaignFooter />
    </Box>
  );
}
